import React, { useState, useEffect } from 'react';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobile = () => {
    setMobileOpen(!mobileOpen);
    document.body.style.overflow = !mobileOpen ? 'hidden' : '';
  };

  const closeMobile = () => {
    setMobileOpen(false);
    document.body.style.overflow = '';
  };

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Products', href: '#products' },
    { label: 'Services', href: '#services' },
    { label: 'Waitlist', href: '#waitlist' },
  ];

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`} id="navbar">
      <a href="#hero" className="nav__logo" onClick={closeMobile}>
        <img src="/images/logo.svg" alt="200 OK Studios Logo" style={{ height: '36px' }} />
      </a>

      <ul className="nav__links">
        {navLinks.map((link) => (
          <li key={link.label}>
            <a href={link.href} className="nav__link">
              {link.label}
            </a>
          </li>
        ))}
      </ul>

      <a href="#waitlist" className="nav__cta">Join Waitlist</a>

      <button
        className={`nav__toggle ${mobileOpen ? 'active' : ''}`}
        onClick={toggleMobile}
        aria-label="Toggle navigation menu"
        id="nav-toggle"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav__mobile-menu ${mobileOpen ? 'open' : ''}`}>
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="nav__mobile-link"
            onClick={closeMobile}
          >
            {link.label}
          </a>
        ))}
        <a href="#contact" className="btn btn--primary" onClick={closeMobile}>
          Get in Touch
        </a>
      </div>
    </nav>
  );
};

export default NavBar;
